import React, { useEffect, useState } from 'react'
import { Container, Row,Button, Col,  Form, Table } from 'react-bootstrap'
import DeliveryHeader from './DeliveryHeader'
import './DeliveryLogin.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Autocomplete, Paper, TextField } from '@mui/material'
import { CustomerFindAll, DeliveryDashboardAdd, DeliveryDashboardDelete, DeliveryDashboardFindAll, DeliveryDashboardOuterFindAll, DeliveryDashboardUpdate, DeliveryProductAdd, DeliveryProductFindAll, EmployeeFindAll, ProductFindAll } from '../Admin/API/Api'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

const DeliveryList = () => {

    const [selectedCustomerName, setSelectedCustomerName] = useState('');
    const [isEditing, setisEditing] = useState(false)
    const [show, setShow] = useState(false);
    const [data, setData] = useState([]);
    const [orderData, setOrderData] = useState([]);
    const [orderId, setOrderId] = useState()
    const [id, setId] = useState()
    const [product_master, setProduct_master] = useState([]);
    const [employee_master, setEmployee_master] = useState([]);
    const [customer_master, setCustomer_master] = useState([]);
    const [productId, setProductId] = useState();
    const [employeeId, setEmployeeId] = useState();
    const [customerId, setCustomerId] = useState();
    const [quantity, setQuantity] = useState();
    const [amount, setAmount] = useState();
    const [date, setDate] = useState();
  
    const handleClose = () => setShow(false);
    const handleShow = (item) => {
      setSelectedCustomerName(item.customer_name);
      setOrderId(item.order_id);
      setId(item.id);
      setCustomerId(item.customer_id);
      setEmployeeId(item.employee_id);
      setQuantity(item.quntity);
      setAmount(item.amount);
      setShow(true);
    };
    const [showEdit, setShowEdit] = useState(false);
  
    // =========== delete modal =========
    const [show1, setShow1] = useState(false);
    const handleClose1 = () => setShow1(false);
  
    const [itemToDelete, setItemToDelete] = useState(null);
  
    const handleShow1 = (item) => {
      setItemToDelete(item);
      setShow1(true);
    };
  
  
    //  =========== Edit ======
    const handleEditClose = () => {
      setShowEdit(false);
      setOrderId('');
      setId('');
      setProductId('');
      setQuantity('');
      setAmount('');
    };
  
    const setEditDataFun = (item) => {
      setProductId(item.product_id);
      setCustomerId(item.customer_id);
      setQuantity(item.quntity);
      setAmount(item.rate);
      setOrderId(item.order_id);
      setId(item.id);
      setisEditing(true)
    }
  
    const updateDeliveryList = () => {
  
      if (!selectedCustomerName || !productId || !quantity || !amount) {
        alert("Please fill in all the fields");
        return;
      }
  
      const formData = {
        product_id: productId,
        quntity: quantity,
        amount: amount
      };
      console.log("form dat...", formData);
      axios
        .put(`${DeliveryDashboardUpdate}${orderId}`, formData)
        .then((res) => {
          console.log("order update res....", res.data)
          if (res.data.message === "UPDATE") {
  
            toast.success("Data Updated Successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            Getdata();
            // GetOrderdata();
  
            handleEditClose();
          }
          else if (res.data === 'ALREADYEXIST') {
            toast.info('Data already exists.', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
        })
        .catch((err) => {
          // Add debugging information to identify the issue
          console.error("Error while updating Employee:", err);
          if (err.response) {
            console.error("Response data:", err.response.data);
          }
  
          toast.error("Failed to update data, please try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        });
    };
  
  
    const savedata = (e) => {
      e.preventDefault();
  
      if (!date || !productId || !amount || !amount) {
        alert("Please fill in all fields");
        return;
      }
    
      const obj = {
        date: date,
        customer_id: customerId,
        employee_id: employeeId,
        product_id: productId,
        quantity: quantity,
        amount: amount,
      }
      console.log("FormData", obj)
  
      axios
        .post(DeliveryProductAdd, obj)
        .then((res) => {
          console.log("res", res.data)
          if (res.data === "SAVED") {
            console.log("res.data", res.data)
            toast.success("Data Saved Successfully!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            // Reset form fields and reload the data
            Getdata();
            // GetOrderdata('');
            setProductId('');
            setQuantity('');
            setAmount('');
            setOrderId('');
            setId('');
            // setShow(false);
            // window.location.reload(); // Note: Reloading the entire page may not be the best practice, consider updating the data from the API.
          } else if (res.data === 'ALREADYEXIST') {
            toast.info('Data already exists.', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
        })
        .catch((err) => {
          toast.error("Failed to upload, please try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.error(err);
        });
    };
  
    //Getdata Logic
    const Getdata = (e) => {
  
      if (!customerId) {
        // customerId is not set, handle accordingly
        return;
      }
  
      axios
        .get(`${DeliveryDashboardFindAll}/${customerId}`)
        .then((res) => {
          console.log("findal inner table", res.data)
          if (res.data !== null) {
            setData(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
    const GetOrderdata = (e) => {
  
      if (!date) {
        // employeeId is not set, handle accordingly
        return;
      }
      setOrderData([]);
      axios
        .get(`${DeliveryProductFindAll}/${id}`)
        .then((res) => {
          console.log("findallllllllll", res.data)
          console.log("findallllllllll", res.data.length)
          if (res.data.length === 0) {
            console.log("in else block ");
            toast.warn("Data Not Allocated...")
          }
          else if (res.data !== null) {
            console.log("in if block ");
            setOrderData(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
    useEffect(() => {
      Getdata();
      GetOrderdata()
    }, [customerId, date])
    useEffect(() => {
      if (show) {
        // Reload data when the modal is shown
        Getdata();
      }
    }, [show, customerId, employeeId]);
  
    //delete data
    const onDelete = (item) => {
      console.log("Deleting item:", item);
      axios
        .delete(`${DeliveryDashboardDelete}${item.order_id}`)
        .then((res) => {
          console.log("Delete response:", res.data);
          if (res.data === "DELETE") {
            // alert("File Deleted Succesfully");
            toast.success("Data Deleted Succesfuly!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
          handleClose1(false)
          Getdata();
          GetOrderdata();
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          console.log("Error deleting item:", err);
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
    //CustomerData Logic
    const Customerdata = (e) => {
      axios
        .get(CustomerFindAll)
        .then((res) => {
          if (res.data !== null) {
            setCustomer_master(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
  
    //Product Logic
    const Productdata = (e) => {
      axios
        .get(ProductFindAll)
        .then((res) => {
          if (res.data !== null) {
            setProduct_master(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
    //Employeedata Logic
    const Employeedata = (e) => {
      axios
        .get(EmployeeFindAll)
        .then((res) => {
          if (res.data !== null) {
            setEmployee_master(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
    useEffect(() => {
      if (isEditing === false) {
        Getdata();
        GetOrderdata();
        Productdata();
        Customerdata();
        Employeedata();
  
      }
    }, [isEditing]);
  
    //HEADING FONT ===================
  
    const headingStyle = {
      fontSize: '27px',
      fontWeight: 'bold',
      textAlign: 'center',
    };
  
    const subheadingStyle = {
      color: 'rgb(255, 93, 0)', // Assuming this is the color for "text-violet-800"
      fontWeight: 300, // Assuming this is the font weight for "font-[300]"
      textShadow: "3px 1px 5px rgb(180, 180, 180)",
    };
  
  return (
    <Container fluid>
        <Row><DeliveryHeader /></Row>

    <Row >
        {/* ====================== table =============== */}
        <Row className='m-0 p-0  px-md-5  py-1 mb-5  w-100' style={{ display: "flex" }}>
    
    <Row className='pt-3'>
      <div className="heading text-black pt-3 pt-2 pt-md-2 mt-2 mt-md-1 mb-4" style={headingStyle}>
        <span style={subheadingStyle}>Product Delivery</span> 
      </div>
    </Row>


    <Row className='m-0 p-0'>
   
    <Col>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
        <DatePicker
         defaultValue={dayjs()} 
         format="DD-MM-YYYY"
          label="Select Date"
          slotProps={{ textField: { size: 'small' } }}
        />
      </DemoContainer>
    </LocalizationProvider>
    </Col>
   </Row>

  <Row className='m-0 p-0'>
    <Col sm={12} md={3} className='mt-3'>
        <Form.Label><h6><b>Customer :</b></h6></Form.Label>
        <Autocomplete
        disablePortal
        id='combo-box-demo'
        size='small'
        style={{ width: '100%' }}
        options={customer_master}
        getOptionLabel={(option) => option.customer_name} // Assuming customer_name is the label
        value={customer_master.find((item) => item.customer_id === customerId) || null}
        onChange={(e, newValue) => setCustomerId(newValue ? newValue.customer_id : '')}
        renderInput={(params) => <TextField {...params} label='Select Customer' />}
        />
    </Col>

    <Col sm={12} md={3} className='mt-3'>
    <Form.Label><h6><b>Employee :</b></h6></Form.Label>
        <Autocomplete
        disablePortal
        id="combo-box-demo"
        size="small"
        style={{ width: '100%' }}
        options={employee_master}
        getOptionLabel={(option) => option.name}
        value={employee_master.find((item) => item.employee_id === employeeId) || null}
        onChange={(e, newValue) => setEmployeeId(newValue ? newValue.employee_id : '')}
        renderInput={(params) => <TextField {...params} style={{ width: '280px' }} label="Select Employee" />}
        />
    </Col>

    <Col sm={12} md={3} className='mt-3'>
        <Form.Label><h6><b>Product :</b></h6></Form.Label>
        {isEditing ? (
            <TextField
            size="small"
            label="Select Product"
            value={product_master.find((item) => item.product_id === productId)?.product_name || ''}
            readOnly
            style={{ width: '100%' }} // Set the desired width
            />
        ) : (
            <Autocomplete
            disablePortal
            size="small"
            id="combo-box-demo"
            options={product_master}
            getOptionLabel={(option) => option.product_name}
            value={product_master.find((item) => item.product_id === productId) || null}
            onChange={(e, newValue) => setProductId(newValue ? newValue.product_id : '')}
            renderInput={(params) => <TextField {...params} label="Select Product" style={{ width: '100%' }} />} // Set the desired width
            />
        )}
        </Col>

        <Col sm={6} md={1} className='mt-3 mb-3'>
            <Form.Label><h6><b>Quantity :</b></h6></Form.Label>
            <TextField
                size="small"
                type="number"
                placeholder="Enter Quantity"
                pattern="[0-9]"
                required
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                style={{ width: '100%' }} // Set the desired width
            />
            </Col>

            <Col sm={6} md={2} className='mt-3 mb-3'>
            <Form.Label><h6><b>Amount :</b></h6></Form.Label>
            <TextField
                size="small"
                type="number"
                placeholder="Enter Amount"
                pattern="[0-9]"
                required
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                style={{ width: '100%' }} // Set the desired width
            />
     </Col>

    </Row>

    <Row className='mt-2 mb-3'>
        <Col style={{ display: "flex", justifyContent: "center" }}>
        {isEditing === false ? (
            <Button
            style={{
                border: "0px",
                backgroundImage:
                "linear-gradient( 180.5deg, rgba(214, 234, 248)  12.3%, rgb(64, 224, 208) 92% )",
                borderRadius: "15px",
            }}
            className="py-2 px-3 mx-2 shadow text-dark"
            type="submit"
            onClick={savedata}
            >
            Save
            </Button>
        ) : (
            <Button
            style={{
                border: "1px solid darkslategray",
                backgroundColor: "darkslategray",
                borderRadius: "15px",
            }}
            className="py-2 px-3 mx-2 shadow text-light"
            type="submit"
            onClick={updateDeliveryList}
            >
            Update
            </Button>
        )}
        </Col>
    </Row>

    <div style={{ overflowY: 'auto' }}>
      <div style={{ overflowX: 'auto' }}>
        <Table striped bordered hover size="sm" className='shadow mt-2' style={{ textAlign: "center" }}>
          <thead >
            <tr >
              <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Sr.No</th>
              <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Date</th>
              <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Product</th>
              <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Quantity</th>
              <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Amount</th>
              <th style={{ alignItems: "center", backgroundColor: "darkslategray", fontSize: "13px", fontFamily: "sans-serif" }} className='text-center text-light'>Total</th>
            </tr>
          </thead>
          <tbody>
            {orderData.map((item, index) => {
              return (
                <tr className='border' style={{ width: '100%',justifyContent:"center", alignContent:"center" }}>
                  <td style={{ textAlign: "center", width: '10%' }}>{index + 1}</td>
                  <td style={{ textAlign: "center"}}>{item.date}</td>
                  <td style={{ textAlign: "center"}}>{item.product_id}</td>
                  <td style={{ textAlign: "center"}}>{item.quantity}</td>
                  <td style={{ textAlign: "center"}}>{item.rate}</td>
                  <td style={{ textAlign: "center"}}>{item.total}</td>
                  
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>
    </div>
     </Row>

     </Row>
    </Container>
  )
}

export default DeliveryList






